<template>
  <span>
    <b-container fluid>
      <b-row class="justify-content-center">
        <b-col>
          <b-card title="Gestion des projets">
            <b-form @submit.prevent="onSubmit">
              <collapse-card :creation-modification="selectedProjet.id">
                <b-row>
                  <b-col sm>
                    <b-form-group
                      :invalid-feedback="veeErrors.first('libelle')"
                      label="Libelle"
                      label-for="libelle"
                      required
                    >
                      <b-form-input
                        id="libelle"
                        v-model="selectedProjet.libelle"
                        v-validate="'required|max:40'"
                        :state="veeErrors.has('libelle') ? false : null"
                        name="libelle"
                        type="text"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col sm>
                    <b-form-group
                      :invalid-feedback="veeErrors.first('dateDebut')"
                      label="Date de début"
                      label-for="dateDebut"
                      required
                    >
                      <date-picker
                        v-model="selectedProjet.dateDebut"
                      ></date-picker>
                    </b-form-group>
                  </b-col>
                  <b-col sm>
                    <b-form-group
                      :invalid-feedback="veeErrors.first('dateFin')"
                      label="Date de fin"
                      label-for="dateFin"
                      required
                    >
                      <date-picker
                        v-model="selectedProjet.dateFin"
                      ></date-picker>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <b-form-group
                      :invalid-feedback="veeErrors.first('inputCommentaire')"
                      label="Commentaire"
                      label-for="inputCommentaire"
                      required
                    >
                      <b-form-textarea
                        id="inputCommentaire"
                        v-model="selectedProjet.commentaire"
                        v-validate="'max:200'"
                        :rows="3"
                        :state="
                          veeErrors.has('inputCommentaire') ? false : null
                        "
                        name="inputCommentaire"
                        type="text"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-button
                      class="m-1 float-right"
                      type="submit"
                      variant="primary"
                      >Enregistrer
                    </b-button>
                    <b-button
                      class="m-1 float-right"
                      variant="danger"
                      @click="resetForm()"
                    >
                      Annuler
                    </b-button>
                  </b-col>
                </b-row>
                <b-col></b-col>
              </collapse-card>
            </b-form>

            <custom-tab
              :tableData="projets"
              :tableFields="tableFields"
              libelleSuppressionProperty="libelle"
              messageSuppression="Confirmez-vous la suppression du projet"
              @deleteConfirmed="deleteProjet"
              @editSelected="onSelectEditProjet"
            ></custom-tab>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </span>
</template>

<script>
import ToastService from "@/service/toastService";
import ApiService from "@/service/apiService";
import DatePicker from "@/components/DatePicker";
import CollapseCard from "../components/CollapseCard";
import CustomTab from "../components/CustomTab";

//Je met ça ici pour épurer l'attribut data
var tableColumns = [
  {
    key: "libelle",
    label: "Libelle",
    sortable: true,
  },
  {
    key: "dateDebut",
    label: "Date de début",
    sortable: true,
  },
  {
    key: "dateFin",
    label: "Date de fin",
    sortable: true,
  },
  {
    key: "commentaire",
    label: "Commentaire",
    sortable: true,
  },
  {
    key: "Actions",
    label: "",
  },
];

export default {
  name: "projet",
  components: {
    DatePicker,
    CollapseCard,
    CustomTab,
  },
  data() {
    return {
      //Tableau des projets récupérés du serveur
      projets: [],

      //Projet selectionné pour la suppression
      selectedProjet: {},

      //Champs qu'affichera le tableau des projets
      tableFields: tableColumns,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    /**
     * Méthode appelé aprés la montage du composant
     */
    init() {
      this.findProjets();
    },
    /**
     * Action aprés la validation du formulaire de creation/modification d'un projet
     */
    onSubmit() {
      var vm = this;
      //On vérifie les champs
      this.$validator.validateAll().then((result) => {
        if (result) {
          ApiService.projet.createUpdate(this.selectedProjet).then((resp) => {
            ToastService.displaySuccessToast(resp.data.message);
            this.resetForm();
            //On recharge les projets pour les actualiser
            this.findProjets();
          });
        }
      });
    },
    /**
     * Récupére la liste de tous les projets du serveur
     */
    findProjets() {
      ApiService.projet.findProjets().then((resp) => {
        this.projets = resp.data;
      });
    },
    /**
     * Envoi la requete de suppression d'un projet
     */
    deleteProjet(projet) {
      ApiService.projet.deleteProjet(projet.id).then((resp) => {
        ToastService.displaySuccessToast(resp.data.message);

        for (var i = 0; i < this.projets.length; i++) {
          if (this.projets[i].id == projet.id) {
            this.projets.splice(i, 1);
            break;
          }
        }
      });
    },

    /**
     * Action lorsqu'on clique sur l'icone pour modifier un projet
     */
    onSelectEditProjet(item) {
      //On vide d'abord l'existant
      this.resetForm();
      this.selectedProjet = Object.assign(this.selectedProjet, item);
    },

    /**
     * Réinitialise le formulaire
     */
    resetForm() {
      this.selectedProjet = {};
      this.$validator.reset();
    },
  },
};
</script>
